import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import { PURCHASES_LIST_PAGE_SIZE } from '@/api/handlers/resources/purchases/queries';
import type { GetReceivedInvoicesResponse } from '@/api/handlers/resources/purchases/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { PurchaseQueryKeys } from './purchaseQueryKeys';

/**
 * Reads `GET /purchases/received-invoices`. Pass `supplierId` to narrow to one
 * supplier — what the Record Payment form offers as allocation targets
 * (BOS-120). Disabled until there is a supplier when one is expected, so the
 * form can mount before a row is chosen.
 */
export const useReceivedInvoicesQuery = (
    supplierId: string | null,
    enabled = true,
    pageSize = PURCHASES_LIST_PAGE_SIZE,
) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetReceivedInvoicesResponse>>({
        queryKey: PurchaseQueryKeys.receivedInvoices(pageSize, supplierId),
        queryFn: () =>
            apiClient.purchases.getReceivedInvoices(
                { pageSize },
                supplierId ?? undefined,
            ),
        enabled: enabled && supplierId !== null,
        staleTime: 60_000,
    });
};
